import React,{useEffect,useState,useRef} from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import ProductLists from "../../components/ProductList";
import Footer from "../../components/Footer";
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import queryString from "query-string";
import Axios from '../../lib/axios/axiosInstance';

import './ProductList.styles.css';

const ProductList = () => {
	
	const [url, setUrl] = useState(false);
	const [leftUrl, setLeftUrl] = useState(false);
	const [baseUrl, setBaseUrl] = useState(false);
	const queryParams = queryString.parse(window.location.search)
	const [name, setName] = useState('All Products');

	useEffect(() => {
		setUrl(false)
	}, [])

	useEffect(() => {
		const getName = async () => {
			let response = await Axios.get(`/category/name/${queryParams.name}`);
			if (response && response.status == 200) {
				setName(response.data.data.getproductvarname);
			}
			else {
				setName(queryParams.name);
			}
		};
		if(queryParams.name!='all'){
			getName().catch(console.error);	
		}else{
			setName('All Products');
		}
			
		setLeftUrl(queryParams.name=='all'?"/category/shop-by/general-office-supplies":"/category/shop-by/"+queryParams.name);
		setBaseUrl("/category/"+queryParams.name);
		setUrl((queryParams.name=='all'?"/category/all":"/category/"+queryParams.name)+"?limit=16&offset=0");
	}, [queryParams])

	return (
		<div>
			{
				url &&
				<>
					<Helmet>
					<title>Product List</title>
					</Helmet>
					<Header />
            		<ActiveCatalogue/> 
					<ProductLists baseUrl={baseUrl} url={url} leftUrl={leftUrl} productBasename={name}/>
					<Footer />	
				</>
			}
			
		</div>
	);
};

export default ProductList;